// @flow

export type FSA<T, P = void, M = { +name: string }> = $ReadOnly<{|
  +type: T,
  +meta?: M,
  +payload: P,
|}>;

export const fsa = <T, P, M>(type: T, payload: P, meta: M): FSA<T, P, M> => ({
  type,
  payload,
  meta,
});
